import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import ReactSVG from 'react-svg';
import ReactGA from 'react-ga';
import Modal from 'react-responsive-modal';
import Responsive from 'react-responsive';
import { Dropdown } from 'semantic-ui-react';
import LogRocket from 'logrocket';
import StepsHeader from './StepsHeader';
import HairSteps from '../hair/header/HairStepsHeader';

import Referral from '../referral/Referral';
import { signOut } from '../../actions/authActions';
import './AppHeader.css';
import { Desktop, Mobile } from '../../utils/styles';
import MobileNavMenu from './MobileNavMenu';
import MobileNavMenuItems from './MobileNavMenuItems';
import * as aaUtil from '../../ath/utils/aaUtils';
import { buttonsContentManage } from '../../utils/util';

// cart 所需文件
import { Elements,StripeProvider } from 'react-stripe-elements';
import RecommendationsCheckout from '../../views/recommendations/RecommendationsCheckout';
// 操作cart 的方法
import { addOrDeleteCartGoodsData,deleteAllCartGoodsData } from '../../actions/cartAction';

import Api from '../../utils/api';

let dropdownOptions, dropdownOptionsShowHair, dropdownOptionsNoSkin;
dropdownOptionsNoSkin = [
  { value: 'logout', text: 'Log out' }
];

let shopMoreOptions = [
    {value: 'newBrands', text: 'New Brands We Love'},
    {value: 'shopHelloava', text: 'HelloAva Shopping Guides'},
    {value: 'collectionsAll', text: 'Everything Store'}
];

dropdownOptions = [
  { value: 'account', text: 'Account Settings' },
  { value: 'order-history', text: 'Order history' },
  { value: 'wishlist', text: 'Wishlist' },
//   { value: 'reviewed-products', text: 'Reviewed Products' },
  { value: 'logout', text: 'Log out' }
];

dropdownOptionsShowHair = [
  { value: 'account', text: 'Account Settings' },
  { value: 'order-history', text: 'Order history' },
  { value: 'wishlist', text: 'Wishlist' },
//   { value: 'reviewed-products', text: 'Reviewed Products' },
  { value: 'logout', text: 'Log out' }
];




class AppHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            active: false,
            visitedRecommendations: false,
            currentPage: props.location.pathname,
            // 购物车参数。如果还有别的地方需要把购物车打开。那这些参数都需要 reducer
            openPaymentConfirmModal: false, 
            amountAvailableForDiscount: 0, 
            discountCodes: [],   // 目前没用
            promoCodeSaved: "",
            loadingPurchase: false,
            eligibleForDiscount: localStorage.getItem('recoeligiblefordiscount') ? localStorage.getItem('recoeligiblefordiscount'): false,
            eligiblePreviouslyPurchased: localStorage.getItem("recohasnotpurchased") ? localStorage.getItem("recohasnotpurchased"): false,
            productArr:[],
            purchasedProduct:false,

        };

        this.selectDropdownOption = this.selectDropdownOption.bind(this);
    }

    componentDidMount() {
        if (process.env.REACT_APP_ENV === 'prod') {
            // ReactPixel.pageView();
            window.fbq('track', 'PageView');
            // ReactGA.pageview(this.props.location.pathname + this.props.location.pathname.search);
        }

        const userId = localStorage.getItem("user_id");

        if( localStorage.getItem("visited_recommendations") == "true" ){
            this.setState({visitedRecommendations: true});
        }else{
            this.setState({visitedRecommendations: false});
        }


        if (this.props.location.pathname === '/survey-result' || this.props.location.pathname === '/recommendation-landing' || this.props.location.pathname === '/recommendations' || this.props.location.pathname.includes('/recommendations/products')) window.addEventListener('scroll', this.toggleDropShadow, false);
        else if (this.props.location.pathname === '/') window.addEventListener('scroll', this.toggleHomeAlt, false);
        else if ((this.props.location.pathname !== '/onboarding' && this.props.location.pathname !== '/startonboarding' && this.props.location.pathname !== '/storeonboarding' && this.props.location.pathname !== '/hair/onboarding') && this.props.location.pathname !== '/') document.querySelector(".app-menu").classList.add('dropshadow');

        if (userId && process.env.REACT_APP_ENV === "prod") {
            LogRocket.identify(userId.toString(), {
              name: (localStorage.getItem("user_global_firstname") || "") + " " + (localStorage.getItem("user_global_lastname") || ""),
              email: localStorage.getItem("user_global_email") || ""
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.location.pathname !== this.props.location.pathname) || (prevProps.history.location.pathname !== this.props.history.location.pathname))  {

            if (this.props.location.pathname === '/') window.addEventListener('scroll', this.toggleHomeAlt, false);
            else if (this.props.location.pathname === '/survey-result') {

                if( localStorage.getItem("visited_recommendations") == "true" ){
                    this.setState({visitedRecommendations: true});
                }else{
                    this.setState({visitedRecommendations: false});
                }

            }

          
        }
    }

    componentWillReceiveProps() {
        this.setState({
            active: false
        });
    }

    componentWillUnmount() {
        if (this.props.location.pathname === '/survey-result' || this.props.location.pathname === '/recommendation-landing' || this.props.location.pathname === '/recommendations' || this.props.location.pathname.includes('/recommendations/products')) window.removeEventListener('scroll', this.toggleDropShadow, false);
        else if (this.props.location.pathname === '/') window.removeEventListener('scroll', this.toggleHomeAlt, false);
    }

    toggleDropShadow() {
        let top = document.querySelector(".app-menu");

        if (window.pageYOffset >= 90 && top) {
            top.classList.add('dropshadow');
        } else {
            top.classList.remove('dropshadow');
        }

    }

    toggleHomeAlt() {
        let top = document.querySelector(".app-menu");
        if (window.pageYOffset >= 2 && top) {
            top.classList.add('home-alt');
        } else {
            top.classList.remove('home-alt');
        }
    }

    onOpenModal = () => {
        this.setState({ open: true, active: false });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    gotoOnboarding() {
        if (process.env.REACT_APP_ENV === 'prod') {
            let category = this.props.isAuthenticated || this.props.location.pathname === "/our-process" ? "TakeQuiz" : "Get started (Go to Our Process)";
            let label = this.props.isAuthenticated || this.props.location.pathname === "/our-process" ? "Our Process - NavBar" : "NavBar";
            ReactGA.event({
                category: category,
                action: 'Click',
                label: label,
                value: 1
            });
        }
    }

    selectDropdownOption(event, data) {
        const value = data.value;
        if (value === 'account') {
            this.props.history.push('/account');
        } else if (value === 'order-history') {
            this.props.history.push('/orders');
        } else if (value === 'logout') {
            this.props.signOut();
        } else if (value === 'wishlist') {
            this.props.history.push('/wishlist');
        } else if (value === 'reviewed-products') {
            this.props.history.push('/reviewed-products');
        } else if (value === 'survey-result') {
        	if (!localStorage.getItem("user_has_skin_profile")) this.props.renderHairPopup(false);
          else this.props.history.push('/survey-result');
        } else if (value === 'hair/profile') {
        	if (!localStorage.getItem("user_has_hair_profile")) this.props.renderHairPopup(true);
          else this.props.history.push('/hair/profile');
        }else if(value ==='newBrands'){
            window.open("https://shop.helloava.co/collections/new-brands"); 
        }else if(value ==='shopHelloava'){
            window.location.href = 'http://shop.helloava.co/';
        }else if(value ==='collectionsAll'){
            // window.location.href = 'https://shop.helloava.co/collections/all';
            window.open("https://shop.helloava.co/collections/all"); 
        }
    }

    handleOnClick() {
      this.setState({
          active: !this.state.active
      })
    }

    closeMenu() {
      this.setState({active: false});
    }

    // 关闭付款页面/购物车页面
    closePaymentConfirmModal = () => {
        this.setState({ openPaymentConfirmModal: false, amountAvailableForDiscount: 0, discountCodes: [], promoCodeSaved: "" });
    }

    // 从购物车页面中删除购物车中的产品
    handleDeleteProduct = (product) => {
      let productArr = this.props.cartGoodsList;
      const ind = productArr.indexOf(product);
      let productArrCopy = [];
      if (ind < 0) {
        productArrCopy = [...productArr, product];
      } else {
        productArrCopy = [...productArr.slice(0, ind), ...productArr.slice(ind + 1)];
      }
      if (productArrCopy < 1) this.setState({ openPaymentConfirmModal: false });

      this.props.addOrDeleteCartGoodsData(product)
      this.setState({ productArr: productArrCopy }, () => {
        if (this.state.productArr.length < 1) this.setState({ openPaymentConfirmModal: false });
      });
    }

    // 打开购物车，判断购物车中数量
    openPaymentConfirmModal = () => {
      const count = this.props.cartGoodsList.length
      if (count <= 0) {
          alert("You must select at least one product.");
          return;
      }
      this.setState({ openPaymentConfirmModal: true });
    }

    // 关闭付款页面/购物车页面
    closePaymentConfirmModal = () => {
        this.setState({ openPaymentConfirmModal: false, amountAvailableForDiscount: 0, discountCodes: [], promoCodeSaved: "" });
    }
    // 强制渲染，没有必要
    forceRender = () => {}
    
    toggleLoading= (loadingPurchase) => {
      this.setState({ loadingPurchase: loadingPurchase });
    }
    // 在购物车中，完成购买后。展示ThankYou,关闭购物车页面。清空 localStorage
    showThankYou = (orderIdValue,orderSubtotalValue,sourceOrderId,orderProductsDataValue, goodsNumber) => {
      this.setState({ openPaymentConfirmModal: true, runTutorial: false }, () => {
        for (let key in localStorage) {
          if (key.includes("reco") && !key.includes("enable_")) localStorage.removeItem(key);
        }
        localStorage.removeItem('cart-products-ids');
        this.props.history.push({pathname:"/showThankYou",state:{'orderId':orderIdValue,'orderSubtotal':orderSubtotalValue,'sourceOrderId':sourceOrderId,'orderProductsData':orderProductsDataValue,'orderGoodsNumber':goodsNumber }});
      });
    }
    fun_clickSkinMenuButton() {
         if(localStorage.getItem("user_has_skin_profile")){
             this.props.history.push("/survey-result")
         }else{
            this.props.renderHairPopup(false)
         }
    }

    render() {
        if (this.props.location.pathname === '/onboarding' || this.props.location.pathname === '/startonboarding' || this.props.location.pathname === '/storeonboarding'  || this.props.location.pathname === '/hair/onboarding') {
            // const padding = '1% 0 1em';
            const padding = '12px';

            //Formula used in older verison
            //window.innerHeight * 0.032 + 'px 0';
            return (
                <div className="onboarding-menu" style={{ 'padding': padding }}>
                    <NavLink className="menu-item-center" style={{margin:'auto'}} to="/">
                        <ReactSVG path="/images/helloava-logo.svg" wrapperClassName="svg-wrapper" />
                    </NavLink>
                </div>
            );
        }

        let pageStyle = '';

        if (this.props.location.pathname === '/') {
            pageStyle = 'home';
        }

        const isAuthenticated = this.props.isAuthenticated || !!localStorage.getItem("auth_token");
        const { open } = this.state;

        const dropdownTrigger = (<span>{ localStorage.getItem('user_firstname') }</span> );

        return (
            <div id="app-menu-wrapper" style={this.props.location.pathname === "/recommendation-landing" ? {display:"none"}:{display:"block"} }  className={localStorage.getItem("user_has_hair_profile") && !localStorage.getItem("user_has_skin_profile") ? "app-menu-wrapper no-banner-app-menu" : "app-menu-wrapper"}>
                <div className={ "app-menu " + pageStyle } >

                    <Mobile>
                        <MobileNavMenu handleOnClick={this.handleOnClick.bind(this)} active={this.state.active} />
                    </Mobile>
                    <div className="logo-links">
                        <div className="mobile-top-zone">
                            <NavLink to="/" className="mobil-top-logo-center">
                                <ReactSVG path="/images/helloava-logo.svg" wrapperClassName="svg-wrapper" />
                            </NavLink>
{/*                             
                            {
                            (window.location.pathname != "/" && window.location.pathname.indexOf("hair") == -1 && this.state.visitedRecommendations )  ?
                                <div className="mobil-top-cart-zone cart icon" >
                                    <i className="cart-icon" style={{width: '23px',height: '31px',backgroundSize: 'contain', marginLeft: '0', lineHeight: '40px'}} onClick={this.openPaymentConfirmModal}>{this.props.cartGoodsCount()}</i>
                                </div>
                                :
                                <div></div> 
                            }
 */}
                            <div className="mobil-top-cart-zone cart icon" >
                                <i className="cart-icon" style={{width: '23px',height: '31px',backgroundSize: 'contain', marginLeft: '0', lineHeight: '40px'}} onClick={this.openPaymentConfirmModal}>{this.props.cartGoodsCount()}</i>
                            </div>
                        </div>
                        
                        {
                            localStorage.getItem("auth_token") && localStorage.getItem("gateFeePaid") == "true" ?
                            <Mobile>
                                <div className="middle">
                                    {
                                        (this.props.location.pathname === '/survey-result' || this.props.location.pathname === '/recommendations') || this.props.location.pathname === '/recommendation-landing' || this.props.location.pathname.includes('/recomendations/products') || window.location.pathname === '/hair/recommendations' || window.location.pathname === '/hair/profile' ?
                                        <div className="logged-in-links">
                                            <div className={ this.props.location.pathname === '/survey-result' || this.props.location.pathname === '/hair/profile' ? "link active" : "link" }>
                                                <a onClick={ window.location.pathname.includes("/hair/recommendations") ? aaUtil.event2_click_event('Navigate to Profile (Header) (P2)') : null } href={ this.props.location.pathname.includes("/hair/") ? "/hair/profile" : "/survey-result" }>{ this.props.location.pathname.includes("/hair/") ? "Hair" : "Skin" } Profile</a>
                                            </div>
                                            <div className={ this.props.location.pathname === '/recommendation-landing' || this.props.location.pathname.includes('/recommendations') ? "link active" : "link" }>
                                                <a onClick={ window.location.pathname.includes("/hair/profile") ? aaUtil.event2_click_event('Navigate to Recommendations (Header) (P2)') : null } href={ buttonsContentManage('recommendations_button') }>Recommendations</a>
                                            </div>
                                        </div> :
                                        null
                                    }
                                </div>
                            </Mobile>:null
                        }
                    </div>
                    <Desktop>

                    <div className="middle-right" style={localStorage.getItem("auth_token") ? {}:{ justifyContent: 'flex-end'} }>
                        {
                            localStorage.getItem("auth_token") &&
                            (
                            (this.props.location.pathname === '/survey-result' ||
                            this.props.location.pathname === '/plan' || 
                            this.props.location.pathname === '/recommendations') || 
                            (this.props.location.pathname === '/recommendation-landing' || 
                            this.props.location.pathname.includes('/recommendations/products') || 
                            this.props.location.pathname.includes('/hair/recommendations') || 
                            this.props.location.pathname.includes('/hair/profile')) ) ?

                            <div className="middle">
                                    <div className="logged-in-links">
                                        <div className={ this.props.location.pathname === '/survey-result' || this.props.location.pathname === '/hair/profile' ? "link active" : "link" }>
                                            <a href={ this.props.location.pathname.includes("/hair/") ? "/hair/profile" : "/survey-result" }>{ this.props.location.pathname.includes("/hair/") ? "Hair" : "Skin" } Profile</a>
                                        </div>
                                        <div className={ this.props.location.pathname === '/recommendation-landing' || this.props.location.pathname.includes('/recommendations') ? "link active" : "link" }>
                                            <a href={ buttonsContentManage('recommendations_button') }>Recommendations</a>
                                        </div>
                                    </div>
                            </div>:null
                        }

                        {/* Determine whether to log in or not ： Api.auth_tokenManager() */}
                        <div className="right">

                            {
                                this.props.location.pathname != '/survey-result' && this.props.location.pathname != '/plan'  && this.props.location.pathname != '/recommendations/products'  && this.props.location.pathname != '/recommendations' ? <a className="hair-menu-item" href="/Blog" title="Ava Academy Blog">Ava Academy Blog</a> : null
                            }
                            
                            {
                                ( !( (this.props.location.pathname === '/survey-result' || 
                                this.props.location.pathname === '/plan' ||
                                this.props.location.pathname === '/recommendations') ||  
                                (this.props.location.pathname === '/recommendation-landing' || 
                                this.props.location.pathname.includes('/recommendations/products') || 
                                this.props.location.pathname.includes('/hair/recommendations') || 
                                this.props.location.pathname.includes('/hair/profile')))   ) && 
                                localStorage.getItem("user_id")
                                && localStorage.getItem("user_has_skin_profile")
                                ?
                                <a onClick={ ()=>{ this.fun_clickSkinMenuButton()  }} className="hair-menu-item skin" title="My Skin Profile">My Skin Profile</a> :
                                null
                            }
                         
                            
                            {/* <a className="hair-menu-item" href="https://shop.helloava.co/?utm_source=webapp&utm_medium=nav&utm_campaign=shop_ha" title="Shop More">Shop More</a> */}
                                <div className="dropdown-area" style={{ marginRight: '5%'}}>
                                    <Dropdown style={{marginLeft:'0'}} trigger={ <span>Shop More</span> } options={ shopMoreOptions } onChange={ this.selectDropdownOption } selectOnBlur={ false } />
                                </div>


                            {/* {
                                !((this.props.location.pathname === '/survey-result' || 
                                this.props.location.pathname === '/recommendations') || 
                                (this.props.location.pathname === '/recommendation-landing' || 
                                this.props.location.pathname.includes('/recommendations/products') || 
                                this.props.location.pathname.includes('/hair/recommendations') || 
                                this.props.location.pathname.includes('/hair/profile'))) ?
                                <NavLink className="hair-menu-item hair" to={ !localStorage.getItem("user_has_hair_profile") ? "/hair/landing" : "/hair/profile" }>My Hair</NavLink> :
                                null
                            } */}

                            { isAuthenticated ?
                                <div className="dropdown-area">
                                    <Dropdown style={{marginLeft:'0'}} trigger={ dropdownTrigger } options={ 
                                    (localStorage.getItem("user_has_hair_profile") && !localStorage.getItem("user_has_skin_profile")) ?
                                    dropdownOptionsNoSkin :
                                    window.location.pathname.includes("/survey-result") || window.location.pathname === '/recommendations' ?
                                    dropdownOptionsShowHair :
                                    dropdownOptions 
                                    } onChange={ this.selectDropdownOption } selectOnBlur={ false } />
                                    {
                                    ((window.location.pathname != "/" && window.location.pathname.indexOf("hair") == -1 && localStorage.getItem("visited_recommendations") == "true") || window.location.pathname == "recommendations"  )  ?
                                    <div className="cart-area">
                                        <i className="cart-icon" onClick={this.openPaymentConfirmModal}>{this.props.cartGoodsCount()}</i>
                                        <div className="dividingLine"></div>
                                    </div>
                                    :
                                    <div className="dividing-bold"></div> 
                                    }
                                </div>
                                :
                                <div className="dropdown-area" style={{borderTight: '2px solid #272d67',paddingRight:'20px'}}>
                                    <NavLink className="menu-item" style={{ border: '0'}} to="/signin">Sign In</NavLink>
                                    {
                                        window.location.pathname != "/signin" ? 
                                        <i className="cart-icon" style={{marginLeft:'20px'}} onClick={this.openPaymentConfirmModal}>{this.props.cartGoodsCount()}</i> :null
                                    }
                                </div>
                                }
                                <NavLink to={ buttonsContentManage() } onClick={ () => { this.gotoOnboarding.bind(this); }}>
                                    <button>{ buttonsContentManage('buttonText') }</button>
                                </NavLink>
                        </div>
                    </div>
                    </Desktop>
                    <Mobile>
                      <div className="mobile-menu-container">
                        <MobileNavMenuItems renderHairPopup={ this.props.renderHairPopup } onOpenModal={this.onOpenModal} active={this.state.active} />
                      </div>
                    </Mobile>
                </div>
                <Modal open={open} onClose={this.onCloseModal} little classNames={{ overlay: 'ha-overlay', modal: 'referral-modal' }}>
                    <Referral closeModal={ this.onCloseModal } />
                </Modal>

                <Modal open={ this.state.openPaymentConfirmModal } onClose={ this.closePaymentConfirmModal }
                  classNames={{ overlay: 'ha-overlay payment-confirm-overlay', modal: 'ha-modal payment-confirm-modal', closeIcon: 'ha-modal-close' }} focusTrapped={ true }>
                    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
                    <Elements>
                            <RecommendationsCheckout 
                                    productArr={ this.props.cartGoodsList}
                                    price={ this.props.cartPriceSum() }
                                    amountPaidGateFee={ localStorage.getItem("recogateamount") || this.state.amountPaidGateFee }
                                    name={ localStorage.getItem("user_firstname") + " " + localStorage.getItem("user_lastname")}

                                    discountCodes={ this.state.discountCodes }
                                    eligibleForDiscount={ this.state.eligibleForDiscount }
                                    hasNotPurchased={ this.state.eligiblePreviouslyPurchased }

                                    handleDeleteProduct={ this.handleDeleteProduct }
                                    forceRender={ this.forceRender }
                                    toggleLoading={ this.toggleLoading }
                                    showThankYou={ this.showThankYou }
                                    clearCart={ this.props.deleteAllCartGoodsData }
                                    saveCartForLater={ this.props.addOrDeleteCartGoodsData }
                                    productCart={ this.props.cartGoodsList }
                            />
                    </Elements>
                        </StripeProvider>    
                </Modal>
                {/* 判断是否完成购买 */}
                {
                    this.state.orderEnd ?
                    <div>
                        <img src={`https://www.shareasale.com/sale.cfm?tracking=${this.state.orderId}&amount=${this.state.orderSubtotal}&merchantID=77400&transtype=sale&sscidmode=6&sscid=${Api.fun_shareasaleGetCookie()}` } width="1" height="1"/>
                        <script defer async type="text/javascript" src="https://shareasale-analytics.com/j.js"></script>
                    </div>:<div></div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    const { cartGoodsCount,cartGoodsList, cartPriceSum } = helloava.myCart;
    return { isAuthenticated,cartGoodsCount,cartGoodsList, cartPriceSum };
}

function mapDispatchToProps(dispatch) {
    return {
        signOut: () => dispatch(signOut()),
        addOrDeleteCartGoodsData: (product) => dispatch(addOrDeleteCartGoodsData(product)),
        deleteAllCartGoodsData: () => dispatch(deleteAllCartGoodsData())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppHeader));



// WEBPACK FOOTER //
// ./src/components/header/AppHeader.js